import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ValidatorFn} from '@angular/forms/src/directives/validators';
import {DateService} from '@services/date.service';

@Component({
    selector: 'app-form-date',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './date-input.component.html'
})
export class DateInputComponent implements OnInit {
    @Input() fbControl: FormControl = new FormControl('');
    @Input() pickByFocus = true;
    @Input() format = 'dd.mm.yyyy';
    /**
     * Разрешенные даты от и до
     */
    @Input() from: string;
    @Input() to: string;

    /**
     * Возможность задать дефолтный сдвиг в днях относительно сегодняшней даты,
     * если значения в поле еще нет.
     * defaultDayShift = 0 является сегодняшним днем,
     * -1 вчерашним и
     * 1 завтрашним
     */
    @Input() defaultDayShift: number = null;

    @ViewChild('pickerContainer') private pickerContainer: ElementRef;

    /**
     * Шаблон для маски ввода
     * @type {string}
     */
    inputMaskTemplate = '';

    isPickerHidden = true;

    private validator: ValidatorFn;

    constructor(
        private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.inputMaskTemplate = this.format.replace('dd', '99')
            .replace('mm', '99')
            .replace('yyyy', '9999');

        /**
         * Если значения еще нет и есть дефолтное относительно сегодняшнего дня, то ставим дефолтное
         */
        if (!this.fbControl.value && this.defaultDayShift !== null && !isNaN(Number(this.defaultDayShift))) {
            const date = new Date();

            /**
             * Сдвигаем на количество дней
             */
            date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * this.defaultDayShift);
            this.fbControl.patchValue(DateService.dateToFormat(date));
        }
    }

    updateControlValue(value: string) {
        this.fbControl.patchValue(value);
    }

    showPicker() {

        if (this.fbControl.disabled) {
            this.isPickerHidden = true;
            this.cd.detectChanges();
            return;
        }

        this.isPickerHidden = false;

        if (
            !this.fbControl.errors &&
            this.fbControl.validator &&
            !this.fbControl.touched &&
            !this.fbControl.dirty
        ) {
            this.validator = this.fbControl.validator;
            this.fbControl.clearValidators();
        }

        this.cd.detectChanges();
    }

    hidePicker() {
        this.isPickerHidden = true;
        this.cd.detectChanges();
    }

    onDatePick(data) {
        this.updateControlValue(data.string);
        this.hidePicker();
        this.validate();
    }

    togglePicker() {
        if (this.fbControl.disabled) {
            this.isPickerHidden = true;
            return;
        }
        this.isPickerHidden = !this.isPickerHidden;
    }

    /**
     * TODO Жуткий костыль!
     *
     * Из-за того, что при клике внутри пикера на динамические поля (например год), они перерисовываются, то
     * event.target у события клика является элементом, которого внутри текущего DOM уже нет, поэтому
     * поймать клик вне текущего DOM, когда кликаем по динамическим элементам - нельзя.
     * Это проявляется прежде всего в списке годов и месяцев в датапикеры и тут костыльное решение, чтобы не закрывать пикер когла
     * это не нужно
     * @param event
     */
    checkTarget(event) {
        const parent = event.target.parentElement;
        if (parent && !this.pickerContainer.nativeElement.contains(parent) && !this.isPickerHidden) {
            this.hidePicker();
            this.validate();
        }
    }

    @HostListener('keydown.esc', ['$event'])
    @HostListener('keydown.enter', ['$event'])
    onEscPress(event) {
        event.preventDefault();
        this.hidePicker();
    }

    onInputBlur() {
        if (this.isPickerHidden) {
            this.validate();
        }
    }

    onInputClick() {
        if (this.pickByFocus) {
            this.showPicker();
        }
    }

    private validate() {
        if (this.validator) {
            this.fbControl.setValidators(this.validator);
            this.validator = null;
        }

        this.fbControl.markAsTouched();
        this.fbControl.markAsDirty();
        this.fbControl.updateValueAndValidity();
    }
}
